import { Component } from '@angular/core';
import { ResolveLibModule } from 'resolve-lib';
import { PageWellComponent } from '../page-well/page-well.component';

@Component({
    selector: 'app-no-access',
    imports: [
        ResolveLibModule,
        PageWellComponent
    ],
    templateUrl: './no-access.component.html',
    styleUrl: './no-access.component.scss'
})
export class NoAccessComponent {

}
